import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={18.441}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16433 22901"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974541119632">
        <path
          d="M9054 13279H7379c104 1380 130 5977-3684 8942-9 11-23 35-24 44 1 0 269 636 4545 636 4280 0 4544-636 4548-643-4-7-21-30-27-38-3813-2964-3787-7561-3683-8941zM12325 259c-58-155-207-259-372-259H4479c-164 0-314 104-371 259L26 11180c-39 103-34 215 15 314s132 170 236 201c1074 334 3534 890 7939 890s6865-556 7941-890c102-31 185-102 234-201s55-211 16-314L12325 259z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
